package world.phantasmal.web.shared.logging

class MessageWithThrowable(
    val message: Any?,
    val throwable: Throwable?,
)
